export const hospitalProfileCompleteActions = {
  PROFILE_COMPLETE_HOSPITAL: {
    REQUEST: 'PROFILE_COMPLETE_HOSPITAL_REQUEST',
    SUCCESS: 'PROFILE_COMPLETE_HOSPITAL_SUCCESS',
    FAILURE: 'PROFILE_COMPLETE_HOSPITAL_FAILURE',
    RESET: 'PROFILE_COMPLETE_HOSPITAL_RESET'
  }
};
